module.exports = __webpack_public_path__ + "static/img/model-bg5.7b4085d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/model-bg5.jpg
// module id = ZXUC
// module chunks = 0